export const keyboard = {
	shiftDown: false,
	altDown: false,
	ctrlDown: false,
}